module.exports = __webpack_public_path__ + "static/media/9.762934d0.jpg";